module.exports = __webpack_public_path__ + "images/emoji/electric_plug.d9bce0d1c2ab0e9a7d8e.png";